import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaEdit, FaCircle } from "react-icons/fa";
import { api } from '../../api';
import { toast } from "react-toastify";
import { customStyles } from "../../styles/dataTableStyles";
import Swal from "sweetalert2";

const MasterProduct = ({ addAccess }) => {
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.auth.region);

  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const navigate = useNavigate();
  const [listingReset, setListingReset] = useState(false);



  const fetchMasterProducts = useCallback(async (pageNo, searchKey, pageSize) => {
    try {
      setLoading(true);
      const response = await api.products.getMasterProductList(
        { pageNo, pageSize, sort: "desc", sortBy: "id", searchKey },token
      );
      if (response.success) {
        setProducts(response.data.result);
        setTotalRows(response.data.totalCount);
      }else {
        setProducts([]);
        setTotalRows(0);
      }
    } catch (error) {
       setProducts([]);
       setTotalRows(0);
      console.error("Error fetching products", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

     useEffect(() => {
  
        setPage(1);
      // eslint-disable-next-line
    }, [search]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
    
      fetchMasterProducts(page, search, pageSize);
    }, 500);
    return () => clearTimeout(delaySearch);
  }, [page, search, listingReset, pageSize, fetchMasterProducts]);

 

  const handleDelete = async (id) => {

     Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to inactive this product?",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "rgb(112 110 115)",
            confirmButtonText: "Okay",
          }).then(async (result) => {
            if (result.isConfirmed) {

              try {
                await api.products.deleteMasterProduct({ delete_array: [id], status: false },token);
                toast.success("Product deactivated successfully");
                fetchMasterProducts(page, search, pageSize);
              } catch (error) {
                toast.error("Something went wrong");
              }

            }
            });

  };

      const handleActivate = async (row) => {
  
        Swal.fire({
          title: "Are you sure?",
          text: "Do you really want to activate this product?",
          showCancelButton: true,
          confirmButtonColor: "rgb(68, 170, 68)",
          cancelButtonColor: "rgb(112 110 115)",
          confirmButtonText: "Activate",
        }).then(async (result) => {
        if (result.isConfirmed) {
        try {
          const response = await api.products.deleteMasterProduct({ delete_array: [row.masterProductId],"status":true }, token);
      
          if (response.success) {
            toast.success("Product activated successfully!");
            setListingReset(prev => !prev); // Force re-fetching brands
          } else {
            toast.error("Unable to enable product!");
          }
        } catch (error) {
       
          
        }
  
          }
        });
      };

  const columns = [
    { name: "ID", selector: row => row.masterProductId, sortable: true, width: "80px" },
    { name: "Product Name", selector: row => row.name, sortable: true },
    { name: region.currency ? `Price (${region.currency})` : "Price", selector: row => row.price, width: "100px" },
    { name: "Margin", selector: row => row.margin, width: "100px" },
    { name: "Denomination", selector: row => row.denomination, width: "100px" },
    { name: "Threshold Value", selector: row => row.thresholdValue, width: "100px" },
    { name: "Stock Available", selector: row => row.stockAvailable, width: "140px" },
    { 
      name: "Status", 
      selector: row => (row.status ? "Active" : "Inactive"), 
      cell: row => (
        <span style={{
          padding: "5px 10px", 
          borderRadius: "5px", 
          // color: "#fff", 
          // backgroundColor: row.status ? "#44aa44" : "#ff4b4b",
          color: row.status ? "#44aa44" : "#ff4b4b",
          display: "inline-block",
          minWidth: "80px",
          textAlign: "center"
        }}>
          {row.status ? "Active" : "Inactive"}
        </span>
      ),
      width: "100px"
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
          {row.status ? (
          <>
          <button className="btn btn-primary btn-sm" onClick={() => navigate(`/view-master/${row.masterProductId}`)}>
            View
          </button>

             <button
            className="btn btn-info btn-sm"
            onClick={() =>
              navigate("/master-stock-history/" + row.masterProductId)
            }
          >
            Stock History
          </button>
          
          <button className="listButton" onClick={() => navigate(`/edit-master/${row.masterProductId}`)}>
            <FaEdit />
          </button>
          <button title="Click to Inactive"  className="listButton" onClick={() => handleDelete(row.masterProductId)}>
             <FaCircle style={{ fill: 'green' }} />
          </button>

          </>
          ) : (
            <button title="Click to Active" className="listButton" style={{ minWidth: "80px" }} onClick={() => handleActivate(row)}>
              <FaCircle  style={{ fill: 'grey' }}/>
            </button>
          )}
        </div>
      ),
      ignoreRowClick: true,
     
     
      width: "300px"
    }
  ];

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header" >MASTER PRODUCTS</h2>
        <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Product Name"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

<button className="btn new-btn-top btn-primary" style={{ marginLeft: "10px", marginTop: "15px" }}  onClick={() => navigate(`/add-master`)}>
      ADD MASTER PRODUCT
    </button>
         
        </div>
      </div>
      <DataTable
        columns={columns}
        data={products}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={setPage}
        paginationPerPage={pageSize}
        onChangeRowsPerPage={(newPageSize, newPage) => {
          setPageSize(newPageSize);
          setPage(newPage);
        }}
        paginationRowsPerPageOptions={[50, 100,150,200]}
        highlightOnHover
        customStyles={customStyles}
        responsive
        noHeader={false}
        noTableHead={false}
        wrap
      />
    </div>
  );
};

export default MasterProduct;
